import Button from '@jetbrains/ring-ui/components/button/button'
import ButtonGroup from '@jetbrains/ring-ui/components/button-group/button-group'
import * as React from 'react'

import type {Props} from './OnlyChangedToggle.types'

export default function OnlyChangedToggle({
  showChangedOnly,
  setShowChangedOnly,
  setShowAll,
}: Props) {
  return (
    <ButtonGroup>
      <Button active={!showChangedOnly} onClick={showChangedOnly ? setShowAll : undefined}>
        {'Show all data'}
      </Button>
      <Button active={showChangedOnly} onClick={!showChangedOnly ? setShowChangedOnly : undefined}>
        {'Only different'}
      </Button>
    </ButtonGroup>
  )
}
